import { Link } from 'react-router-dom';
import { ButtonBase, Avatar, Typography, Badge, useTheme } from '@mui/material';
import { ShoppingBag } from 'lucide-react';
import { useNode } from '@craftjs/core';
import { useAppSelector } from '@/hooks';

const CartBlock = () => {
  const theme = useTheme();
  const products = useAppSelector((state) => state.quote.items);

  const {
    connectors: { connect, drag },
  } = useNode((state) => {
    return {
      hasSelectedNode: state.events.selected,
      hasDraggedNode: state.events.dragged,
    };
  });

  return (
    <div ref={(ref: any) => connect(drag(ref))}>
      <ButtonBase component={Link} to={'/checkout'} sx={{ gap: 1 }}>
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          color="primary"
          badgeContent={products?.length}
        >
          <Avatar
            sx={{
              border: `1px solid ${theme.palette.primary.main}`,
              color: theme.palette.primary.main,
              backgroundColor: 'transparent',
            }}
          >
            <ShoppingBag />
          </Avatar>
        </Badge>
        <Typography>Productos</Typography>
      </ButtonBase>
    </div>
  );
};

CartBlock.craft = {
  displayName: 'Compras',
};

export default CartBlock;
